import { render } from "./TemplateLibrary.vue?vue&type=template&id=21389e87&scoped=true"
import script from "./TemplateLibrary.vue?vue&type=script&lang=js"
export * from "./TemplateLibrary.vue?vue&type=script&lang=js"

import "./TemplateLibrary.vue?vue&type=style&index=0&id=21389e87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21389e87"]])

export default __exports__